<template>
  <div v-if="hasFilters" class="q-widget">
    <div class="q-widget__header">
      <span class="q-section-title" style="font-size: 12px;">Filtros activos</span>
    </div>
    <button class="btn btn-sm q-clear-btn" @click="clearAllFilters">
      <i class="bi bi-x-lg me-1"></i>Limpiar filtros
    </button>
    <div class="d-flex flex-wrap gap-2 mt-2">
      <span v-if="searchdata.q != ''" class="q-filter-tag">
        "{{ searchdata.q }}"
        <button class="q-filter-tag__close" @click="removeQuery">
          <i class="bi bi-x"></i>
        </button>
      </span>
      <span v-for="cat in categoryNames" :key="'c' + cat.id" class="q-filter-tag">
        {{ cat.name }}
        <button class="q-filter-tag__close" @click="removeCategory(cat.id)">
          <i class="bi bi-x"></i>
        </button>
      </span>
      <span v-for="brand in brandNames" :key="'b' + brand.id" class="q-filter-tag">
        {{ brand.name }}
        <button class="q-filter-tag__close" @click="removeBrand(brand.id)">
          <i class="bi bi-x"></i>
        </button>
      </span>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  data() {
    return { outData: { uid: this.$route.params.uid, catID: null } };
  },
  computed: {
    ...mapGetters({
      categoryList: "ecommerce/categoryList",
      brands:       "ecommerce/brands",
      searchdata:   "ecommerce/searchdata",
    }),
    categoryNames() {
      return this.categoryList.filter(e => this.searchdata.filters.category.includes(e.id));
    },
    brandNames() {
      return this.brands.filter(e => this.searchdata.filters.brand.includes(e.id));
    },
    hasFilters() {
      return this.categoryNames.length > 0 || this.brandNames.length > 0 || this.searchdata.q !== "";
    },
  },
  methods: {
    ...mapActions({ loadProducts: "ecommerce/loadProducts", loadCatalog: "ecommerce/loadCatalog" }),
    ...mapMutations({
      removeFilterCategory: "ecommerce/REMOVE_FILTER_CATEGORY",
      setPageNumber:        "ecommerce/SET_PAGE_NUMBER",
      setQuery:             "ecommerce/SET_QUERY",
      removeFilterBrands:   "ecommerce/REMOVE_FILTER_BRANDS",
    }),
    removeCategory(id) {
      this.removeFilterCategory(id);
      this.setPageNumber(1);
      this.$route.name === "Catalog"
        ? this.$store.dispatch("ecommerce/loadCatalog", this.outData)
        : this.loadProducts();
    },
    removeBrand(id) {
      this.removeFilterBrands(id);
      this.setPageNumber(1);
      this.loadProducts();
    },
    removeQuery() {
      this.setQuery("");
      this.setPageNumber(1);
      this.$route.name === "Catalog"
        ? this.$store.dispatch("ecommerce/loadCatalog", this.outData)
        : this.loadProducts();
    },
    clearAllFilters() {
      this.categoryNames.forEach(c => this.removeFilterCategory(c.id));
      this.brandNames.forEach(b => this.removeFilterBrands(b.id));
      this.setPageNumber(1);
      this.setQuery("");
      this.$route.name === "Catalog"
        ? this.$store.dispatch("ecommerce/loadCatalog", this.outData)
        : this.loadProducts();
    },
  },
};
</script>

<style scoped>
.q-widget__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.q-clear-btn {
  font-family: var(--q-font-display);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--alert-color);
  border-color: rgba(236, 23, 41, 0.438);
  padding: 2px 8px;
  transition: all var(--q-transition);
}
.q-clear-btn:hover {
  background-color: rgba(202, 34, 48, 0.678);
  border-color: red;
  color: #fff;
}

.q-filter-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background-color: rgba(0, 212, 255, 0.08);
  border: 1px solid rgba(0, 212, 255, 0.2);
  color: var(--primary-color);
  font-family: var(--q-font-mono);
  font-size: 11px;
  padding: 3px 6px 3px 8px;
  border-radius: 3px;
}
.q-filter-tag__close {
  background: none;
  border: none;
  padding: 0;
  color: inherit;
  opacity: 0.6;
  cursor: pointer;
  line-height: 1;
  font-size: 13px;
  transition: opacity var(--q-transition);
}
.q-filter-tag__close:hover { opacity: 1; }
</style>
